
import React, { useState , useEffect } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import DialogLogin from "./DialogLogin";
import DialogNew from "./DialogNew";
import AddClient2 from "../../../../AddClient2";


export default function DialogCard( { isvisible  , notVisible , answer } ) {
    const [visible, setVisible] = useState(false);
    const [isNew,setisNew] = useState( false )

    function crearCuenta()
    {
        console.log( "Solicita crear cuenta")
        setisNew( true )

    }

    useEffect(() => {

        console.log( "isNew = " , isNew )

    } , [isNew])

    useEffect(() => {

        console.log( "useEffect isVisible = " , isvisible  )

        if ( isvisible === true )
        {
            setisNew( false )
        }

        setVisible( isvisible ) ;

    } ,[isvisible])

    return (
        <div className="card flex justify-content-center">
            {/* <Button label="Show" icon="pi pi-external-link" onClick={() => setVisible(true)} /> */}
            <Dialog header={ ( isNew === true ?"Cliente Nuevo" : "Login")} closeOnEscape={true}
                visible={visible} style={{ width:  ( isNew === true ? '75vw' : '50vw' )  }} onHide={() => {if (!visible) return; notVisible()  ; /*setVisible(false); */ }}>
                
                {
                    isNew === false && (
                        <DialogLogin crear={crearCuenta} answer={answer} ></DialogLogin>
                    )
                }

                {
                    isNew === true && (
                        <AddClient2 isExtra={true}></AddClient2>
                    )
                }

                
            </Dialog>
        </div>
    )
}
        